import React from "react";

function formError({ errors, touched }) {
	return (
		<>{errors && touched ? <div style={{ color: "#ff3b30", width: "200px", marginTop: "5px" }}>{errors}</div> : null}</>
	);
}

export default formError;
